import {IS_VERCEL_PROD} from './constants'

const paymentPlansConfig: {[P in TPaymentPlansKeys]: IPaymentPlanConfig} = {
	monthly: {
		key: 'monthly',
		planLabel: 'monthly',
		campaignId: IS_VERCEL_PROD ? 9 : 10,
		billingModelId: 3,
		offerId: 8,
		productId: 8,
		subscription: {
			price: 14.95,
			frequency: 'monthly',
			duration: 30,
		},
		trial: null,
	},
	'monthly-a': {
		key: 'monthly-a',
		planLabel: 'monthly',
		campaignId: IS_VERCEL_PROD ? 6 : 8,
		billingModelId: 3,
		offerId: 7,
		productId: 7,
		subscription: {
			price: 19.95,
			frequency: 'monthly',
			duration: 30,
		},
		trial: null,
	},
	'monthly-b': {
		key: 'monthly-b',
		planLabel: 'monthly',
		campaignId: IS_VERCEL_PROD ? 4 : 5,
		billingModelId: 3,
		offerId: 10,
		productId: 10,
		subscription: {
			price: 27.88,
			frequency: 'monthly',
			duration: 30,
		},
		trial: null,
	},
	annual: {
		key: 'annual',
		planLabel: 'annual',
		campaignId: IS_VERCEL_PROD ? 1 : 3,
		billingModelId: 6,
		offerId: 2,
		productId: 2,
		subscription: {
			price: 89.0,
			frequency: 'yearly',
			duration: 365,
		},
		trial: null,
	},
	single: {
		key: 'single',
		planLabel: 'single',
		campaignId: IS_VERCEL_PROD ? 1 : 3,
		billingModelId: 2,
		offerId: 3,
		productId: 3,
		subscription: {
			price: 39.0,
			frequency: 'once',
		},
		trial: null,
	},
} as const

export default paymentPlansConfig
